// Theme Presets

const lightTheme = {
  name: "light",
  body: "#F8F9FC",
  text: "#0F172A",
  dark: "#000000",
  secondaryText: "#64748B",
  accentColor: "#6366F1",
  accentBright: "#6366F1",
  projectCard: "#EEF2FF",
  skinColor: "#F7B799",
  skinColor2: "#FCB696",
  imageDark: "#E2E8F0",
  imageClothes: "#C7D2FE",
  avatarMisc: "#E0E7FF",
  avatarShoes: "#C7D2FE",
};

const darkTheme = {
  name: "dark",
  body: "#080B14",
  text: "#E2E8F0",
  dark: "#000000",
  secondaryText: "#94A3B8",
  accentColor: "#00D4FF",
  accentBright: "#00D4FF",
  projectCard: "#0D1117",
  skinColor: "#F7B799",
  skinColor2: "#FCB696",
  imageDark: "#111827",
  imageClothes: "#1E293B",
  avatarMisc: "#0F172A",
  avatarShoes: "#1E293B",
};

export const themes = { light: lightTheme, dark: darkTheme };
